import React from "react";
import PropTypes from "prop-types";
import {
  CheckCircleFilled,
  ExclamationCircleFilled,
  CloseOutlined,
} from "@ant-design/icons";
import "./Toast.css";

function Toast(props) {
  const { content, type = "check", onClose } = props;

  const getIcon = () => {
    switch (type) {
      case "check":
        return (
          <CheckCircleFilled data-testid="check-icon" className="toast-icon" />
        );
      case "exclamation":
        return (
          <ExclamationCircleFilled
            data-testid="exclamation-icon"
            className="toast-icon"
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="toast-container">
      {getIcon()}
      <span className="context">{content}</span>
      <CloseOutlined
        onClick={onClose}
        data-testid="close-icon"
        className="toast-close-icon"
      />
    </div>
  );
}

Toast.propTypes = {
  content: PropTypes.string.isRequired,
  type: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default Toast;
